
/* System defined core library */
import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';

/* User defined library/components */
import { HttpService } from './http.service';
import { LoaderService } from '../shared/services/loader.service';
import { AuthGuard } from '../shared/services/activation-guard.service';

/* User defined component/function refrences */
import { throwIfAlreadyLoaded } from './module-import-guard';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [HttpService, LoaderService, AuthGuard]
})

export class CoreModule {

  /* Constructor declaration with required injected services */
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

}
